/*!
 * PQ PDP v0.5 — behaviour for the PQ product-page blocks (s_product.liquid pq_* block types)
 *  - Autoship / Buy once: writes the chosen selling plan to input[name=selling_plan] and keeps the
 *    theme's price re-render in step; re-applies the shopper's choice after every section re-render.
 *  - 2hr Delivery cut-off status: same OPEN/CUTOFF table as the cart widget (pq-fulfilment.js v1.6).
 *  - Store stock checker: REX Shopify connector /outlets endpoint (same as the drawer), postcode sort.
 *  - Sticky add-to-cart bar.
 * All blocks are re-rendered by the theme on variant change, so everything here is idempotent and
 * re-binds via a MutationObserver on the product section.
 */
(function () {
  'use strict';

  /* ---------- shared: Sydney time + 2hr cut-offs (keep in step with pq-fulfilment.js) ---------- */
  var OPEN_TIMES   = { 0: '09:00', 1: '09:00', 2: '09:00', 3: '09:00', 4: '09:00', 5: '09:00', 6: '09:00' };
  var CUTOFF_TIMES = { 0: '15:00', 1: '16:30', 2: '16:30', 3: '16:30', 4: '16:30', 5: '16:30', 6: '15:30' };
  var DAY_IDX = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  var SYDNEY_FORMATTER = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Sydney', hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short', hour: '2-digit', minute: '2-digit' });

  function sydneyParts(date) {
    var o = {};
    SYDNEY_FORMATTER.formatToParts(date).forEach(function (p) { o[p.type] = p.value; });
    return { year: +o.year, month: +o.month, date: +o.day, day: DAY_IDX[o.weekday], hour: (+o.hour) % 24, minute: +o.minute };
  }
  // Fixed annual store-closure dates in Australia/Sydney. These are calendar dates,
  // not observed public-holiday substitutions: Christmas Day (25 Dec), Australia Day (26 Jan).
  function isClosedDay(date) {
    var p = sydneyParts(date || new Date());
    return (p.month === 12 && p.date === 25) || (p.month === 1 && p.date === 26);
  }
  function toMins(hhmm) { var p = hhmm.split(':'); return parseInt(p[0], 10) * 60 + parseInt(p[1], 10); }
  function fmtTime(hhmm) { var m = toMins(hhmm); var h = Math.floor(m / 60), mm = m % 60; var ap = h >= 12 ? 'pm' : 'am'; h = h % 12; if (h === 0) h = 12; return h + ':' + (mm < 10 ? '0' : '') + mm + ' ' + ap; }
  // Convert a Sydney wall-clock deadline into an absolute instant. Iterating the
  // timezone offset makes this DST-aware without assuming a fixed UTC offset.
  function sydneyLocalEpoch(parts, hhmm) {
    var hm = hhmm.split(':').map(Number);
    var target = Date.UTC(parts.year, parts.month - 1, parts.date, hm[0], hm[1]);
    var guess = target;
    for (var i = 0; i < 3; i++) {
      var local = sydneyParts(new Date(guess));
      var represented = Date.UTC(local.year, local.month - 1, local.date, local.hour, local.minute);
      guess += target - represented;
    }
    return guess;
  }
  function remainingText(ms) {
    var minutes = Math.max(0, Math.ceil(ms / 60000));
    var hours = Math.floor(minutes / 60), rest = minutes % 60;
    return hours ? hours + 'h ' + (rest < 10 ? '0' : '') + rest + 'm' : rest + 'm';
  }
  function expressStatus(date) {
    var instant = date || new Date();
    var now = sydneyParts(instant);
    if (isClosedDay(instant)) {
      return { state: 'closed', text: 'Stores are closed today. 2hr delivery and Click & Collect are unavailable today.' };
    }
    var openText = OPEN_TIMES[now.day], cutoffText = CUTOFF_TIMES[now.day];
    var cutoffMins = toMins(cutoffText), nowMins = now.hour * 60 + now.minute;
    var cutoffAt = sydneyLocalEpoch(now, cutoffText);
    var left = cutoffAt - instant.getTime();
    if (nowMins >= cutoffMins || left <= 0) {
      return { state: 'after-cutoff', text: 'Today’s 2hr order cutoff (' + fmtTime(cutoffText) + ' Sydney time) has passed; 2hr ordering is closed for today.' };
    }
    var timer = remainingText(left);
    if (nowMins < toMins(openText)) {
      return { state: 'before-open', text: '2hr ordering opens at ' + fmtTime(openText) + '; today’s cutoff is in ' + timer + ' (Sydney time).' };
    }
    return { state: nowMins >= cutoffMins - 90 ? 'closing' : 'open', text: '2hr order window closes in ' + timer + ' (' + fmtTime(cutoffText) + ' Sydney time).' };
  }

  /* ---------- stores (coords from the drawer; used when REX returns none) ---------- */
  var STORES = {
    '2': { lat: -32.922, lng: 151.729 }, '3': { lat: -32.932, lng: 151.641 }, '4': { lat: -33.033, lng: 151.660 },
    '5': { lat: -33.108, lng: 151.487 }, '6': { lat: -32.715, lng: 151.531 }, '7': { lat: -32.783, lng: 151.638 },
    '9': { lat: -33.311, lng: 151.416 }, '10': { lat: -33.803, lng: 150.851 }
  };
  function haversineKm(a, b, c, d) {
    var R = 6371, dLat = (c - a) * Math.PI / 180, dLng = (d - b) * Math.PI / 180;
    var x = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a * Math.PI / 180) * Math.cos(c * Math.PI / 180) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
  }
  var REX_BASE = 'https://shopify.retailexpress.com.au/api/shopify_stores/' + ((window.Shopify && window.Shopify.shop) || location.hostname).split('.', 1)[0];
  var STORE_KEY = 'pq-pdp-store';   // sessionStorage: { id, name, postcode }
  var PC_KEY = 'pq-pdp-postcode';

  function money(cents) {
    try { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(cents / 100); } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- Autoship / Buy once ---------- */
  var poState = window.__pqPO || (window.__pqPO = { mode: null, planId: null });

  function bindPurchaseOptions(root) {
    root.querySelectorAll('[data-pq-po]').forEach(function (po) {
      if (po.__pqBound) return;
      po.__pqBound = true;
      var input = po.querySelector('[data-pq-po-input]');
      var select = po.querySelector('[data-pq-po-select]');
      var radios = po.querySelectorAll('[data-pq-po-radio]');

      // first paint: decide the mode (server-rendered state wins if a plan is in the URL)
      if (!poState.mode) {
        poState.mode = po.getAttribute('data-mode') === 'autoship' ? 'autoship' : (po.getAttribute('data-default') === 'autoship' ? 'autoship' : 'one_time');
        poState.planId = po.getAttribute('data-mode') === 'autoship' ? input.value : (select ? select.value : po.getAttribute('data-first-plan'));
      }
      apply(false);

      radios.forEach(function (r) {
        r.addEventListener('change', function () {
          poState.mode = r.value;
          if (poState.mode === 'autoship' && select) poState.planId = select.value;
          apply(true);
        });
      });
      if (select) {
        select.addEventListener('change', function () {
          poState.planId = select.value;
          if (poState.mode === 'autoship') apply(true);
          updateAutoshipPrices();
        });
        // guard: clicking the select must not toggle the radio
        select.addEventListener('click', function (e) { e.stopPropagation(); });
      }

      function updateAutoshipPrices() {
        if (!select) return;
        var opt = select.options[select.selectedIndex];
        if (!opt) return;
        var f = po.querySelector('[data-pq-po-first]'), o = po.querySelector('[data-pq-po-ongoing]');
        if (f && opt.getAttribute('data-first')) f.textContent = money(+opt.getAttribute('data-first'));
        if (o && opt.getAttribute('data-ongoing')) o.textContent = money(+opt.getAttribute('data-ongoing'));
      }

      function apply(userAction) {
        var autoship = poState.mode === 'autoship';
        radios.forEach(function (r) { r.checked = (r.value === poState.mode); });
        po.querySelectorAll('.pq-po__opt').forEach(function (l) { l.classList.toggle('is-active', l.querySelector('[data-pq-po-radio]').checked); });
        if (select && poState.planId) select.value = poState.planId;
        var newVal = autoship ? (poState.planId || (select && select.value) || '') : '';
        if (input.getAttribute('value') !== newVal) {
          // setAttribute so the theme's <selling-plan> MutationObserver notices, then a change event for good measure
          input.setAttribute('value', newVal);
          input.value = newVal;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        updateAutoshipPrices();
        applyCtaLabel();
        var referenceVid = currentVariantId();
        updateMemberReference(referenceVid, promoByVid[referenceVid], autoship);
        // client-side price mirror (covers single-variant products where the theme doesn't re-render)
        var section = po.closest('.shopify-section') || document;
        var priceNow = section.querySelector('[data-pq-price-now]');
        var formId = input && (input.getAttribute('form') || (input.form && input.form.id));
        var stickyBar = stickyBarsForForm(formId)[0];
        var sticky = stickyBar && stickyBar.querySelector('[data-pq-sticky-price]');
        var oneTime = po.querySelector('.pq-po__price--once');
        var first = po.querySelector('[data-pq-po-first]');
        var shown = autoship ? (first && first.textContent) : (oneTime && oneTime.textContent);
        if (shown && priceNow && !userAction) { /* server render already right on first paint */ }
        if (shown && userAction) {
          if (priceNow) priceNow.textContent = shown;
          if (sticky) sticky.textContent = shown;
          var pw = section.querySelector('[data-pq-price]');
          if (pw) pw.classList.toggle('is-plan', autoship);
        }
      }
    });
  }

  /* ---------- 2hr cut-off status ---------- */
  function bindCutoff(root, instant) {
    var closed = isClosedDay(instant || new Date());
    var closureCopy = 'Stores are closed today. 2hr delivery and Click & Collect are unavailable today.';
    root.querySelectorAll('[data-pq-ful]').forEach(function (fulfilment) {
      var available = fulfilment.getAttribute('data-variant-available') !== 'false';
      var el = fulfilment.querySelector('[data-pq-ful-cutoff]');
      var item = fulfilment.querySelector('[data-pq-ful-express]');
      var qualifier = fulfilment.querySelector('[data-pq-ful-qualifier]');
      var expressCopy = fulfilment.querySelector('[data-pq-ful-express-copy]');
      var cncCopy = fulfilment.querySelector('[data-pq-ful-cnc-copy]');
      var noteCopy = fulfilment.querySelector('[data-pq-ful-note-copy]');
      [expressCopy, cncCopy, noteCopy].forEach(function (copy) {
        if (!copy) return;
        if (copy.__pqNormalHtml == null) copy.__pqNormalHtml = copy.innerHTML;
        if (copy.__pqNormalText == null) copy.__pqNormalText = copy.textContent;
        if (closed) {
          if (copy.textContent !== closureCopy) copy.textContent = closureCopy;
        } else if (typeof copy.innerHTML === 'string') {
          if (copy.innerHTML !== copy.__pqNormalHtml) copy.innerHTML = copy.__pqNormalHtml;
        } else if (copy.textContent !== copy.__pqNormalText) copy.textContent = copy.__pqNormalText;
      });
      if (!el) return;
      if (qualifier) qualifier.hidden = !available || closed;
      if (closed) {
        el.textContent = closureCopy;
        el.hidden = false;
        if (item) { item.classList.remove('is-open', 'is-closing', 'is-after-cutoff', 'is-before-open'); item.classList.add('is-closed'); }
        return;
      }
      if (!available) {
        el.textContent = '';
        el.hidden = true;
        if (item) item.classList.remove('is-open', 'is-closing', 'is-after-cutoff', 'is-before-open', 'is-closed');
        return;
      }
      el.hidden = false;
      var st = expressStatus(instant);
      if (el.textContent !== st.text) el.textContent = st.text;
      if (item) { item.classList.remove('is-open', 'is-closing', 'is-after-cutoff', 'is-before-open', 'is-closed'); item.classList.add('is-' + st.state); }
    });
    root.querySelectorAll('[data-pq-stock-express]').forEach(function (badge) { badge.hidden = closed; });
    bindAvailability(root, instant);
  }

  /* ---------- store stock checker ---------- */
  function bindStock(root) {
    root.querySelectorAll('[data-pq-stock]').forEach(function (box) {
      if (box.__pqBound) return;
      box.__pqBound = true;
      var ful = box.closest('[data-pq-ful]');
      var variantId = ful.getAttribute('data-variant-id');
      var klass = ful.getAttribute('data-class');
      var toggle = box.querySelector('[data-pq-stock-toggle]');
      var panel = box.querySelector('[data-pq-stock-panel]');
      var form = box.querySelector('[data-pq-stock-form]');
      var pcInput = box.querySelector('[data-pq-stock-pc]');
      var msg = box.querySelector('[data-pq-stock-msg]');
      var list = box.querySelector('[data-pq-stock-list]');
      var chosen = box.querySelector('[data-pq-stock-chosen]');
      var outlets = null, loc = null;

      var savedPc = sessionStorage.getItem(PC_KEY);
      if (savedPc) pcInput.value = savedPc;
      renderChosen();

      toggle.addEventListener('click', function () {
        var open = panel.hasAttribute('hidden');
        panel.toggleAttribute('hidden', !open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        box.classList.toggle('is-open', open);
        if (open && !outlets) load();
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var pc = (pcInput.value || '').trim();
        if (!/^\d{4}$/.test(pc)) { msg.textContent = 'Please enter a 4-digit Australian postcode.'; return; }
        sessionStorage.setItem(PC_KEY, pc);
        geocode(pc).then(function (l) {
          loc = l; msg.textContent = l ? '' : 'We couldn’t find that postcode — stores shown unsorted.';
          render();
        });
      });

      // auto-open + auto-search when the product can't be posted (the shopper has to pick a store anyway)
      if (klass === 'livestock' || klass === 'fresh') toggle.click();

      function load() {
        msg.textContent = 'Checking store stock…';
        list.innerHTML = '';
        fetch(REX_BASE + '/outlets?variant_ids=' + encodeURIComponent(variantId) + '&qty-' + encodeURIComponent(variantId) + '=1')
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function (json) {
            outlets = (json.outlets || []).map(function (o) {
              var have = (o.stock && o.stock[variantId]) || 0;
              var c = o.contact || {};
              var coord = STORES[String(o.external_id)];
              return { id: String(o.external_id), name: o.name, qty: +have, contact: c,
                       lat: parseFloat(c.latitude) || (coord && coord.lat), lng: parseFloat(c.longitude) || (coord && coord.lng) };
            });
            msg.textContent = '';
            var pc = sessionStorage.getItem(PC_KEY);
            if (pc && !loc) return geocode(pc).then(function (l) { loc = l; render(); });
            render();
          })
          .catch(function (err) {
            console.warn('[PQ PDP] stock fetch failed', err);
            msg.textContent = 'We couldn’t check store stock right now. Please try again shortly or call your store.';
          });
      }

      function geocode(pc) {
        return fetch('https://api.zippopotam.us/AU/' + pc).then(function (r) { if (!r.ok) throw 0; return r.json(); })
          .then(function (j) { var p = j.places && j.places[0]; return p ? { lat: +p.latitude, lng: +p.longitude } : null; })
          .catch(function () {
            return fetch('https://nominatim.openstreetmap.org/search?format=json&limit=1&countrycodes=au&postalcode=' + pc)
              .then(function (r) { return r.json(); }).then(function (a) { return a && a[0] ? { lat: +a[0].lat, lng: +a[0].lon } : null; })
              .catch(function () { return null; });
          });
      }

      function render() {
        if (!outlets) return;
        var rows = outlets.slice();
        if (loc) rows.forEach(function (o) { o.km = (isFinite(o.lat) && isFinite(o.lng)) ? haversineKm(loc.lat, loc.lng, o.lat, o.lng) : undefined; });
        rows.sort(function (a, b) {
          if (loc && a.km != null && b.km != null && a.km !== b.km) return a.km - b.km;
          if ((b.qty > 0) !== (a.qty > 0)) return (b.qty > 0) ? 1 : -1;
          return a.name.localeCompare(b.name);
        });
        var saved = getChosen();
        list.innerHTML = rows.map(function (o) {
          var c = o.contact || {};
          var status = o.qty > 0 ? (o.qty <= 3 ? '<span class="pq-ful__stock is-low">Low stock (' + o.qty + ' left)</span>' : '<span class="pq-ful__stock is-in">In stock</span>') : '<span class="pq-ful__stock is-out">Out of stock</span>';
          var within = (o.km != null && o.km <= 15) ? '<span class="pq-ful__eligible" data-pq-stock-express>2hr Delivery likely available</span>' : '';
          return '<label class="pq-ful__store ' + (o.qty > 0 ? '' : 'is-out') + (saved && saved.id === o.id ? ' is-chosen' : '') + '">' +
            '<input type="radio" name="pq-store" value="' + esc(o.id) + '" ' + (saved && saved.id === o.id ? 'checked' : '') + (o.qty > 0 ? '' : ' disabled') + '>' +
            '<span class="pq-ful__store-body">' +
              '<span class="pq-ful__store-row"><strong>' + esc(o.name.replace(/^PETQuarters\s+/i, '')) + '</strong>' + (o.km != null ? '<span class="pq-ful__km">~' + o.km.toFixed(1) + ' km</span>' : '') + '</span>' +
              '<span class="pq-ful__store-addr">' + esc([c.address1, c.suburb, c.state, c.postcode].filter(Boolean).join(', ')) + '</span>' +
              '<span class="pq-ful__store-status">' + status + (klass !== 'livestock' ? within : '') + '</span>' +
            '</span></label>';
        }).join('');
        list.querySelectorAll('input[name="pq-store"]').forEach(function (r) {
          r.addEventListener('change', function () {
            var o = rows.find(function (x) { return x.id === r.value; });
            setChosen({ id: o.id, name: o.name, postcode: (o.contact || {}).postcode });
            list.querySelectorAll('.pq-ful__store').forEach(function (l) { l.classList.toggle('is-chosen', l.querySelector('input').checked); });
            renderChosen();
          });
        });
      }
      function getChosen() { try { return JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null'); } catch (e) { return null; } }
      function setChosen(o) { sessionStorage.setItem(STORE_KEY, JSON.stringify(o)); document.dispatchEvent(new CustomEvent('pq:store-chosen', { detail: o })); }
      function renderChosen() {
        var s = getChosen();
        if (!s) { chosen.setAttribute('hidden', ''); return; }
        chosen.removeAttribute('hidden');
        chosen.innerHTML = 'Your store: <strong>' + esc(s.name.replace(/^PETQuarters\s+/i, '')) + '</strong> — we’ll suggest it again in the cart.';
      }
    });
  }

  /* ---------- sticky add-to-cart ---------- */
  var stickyObserver = null;
  var stickyObservedTarget = null;
  var stickyObservedForm = null;
  var stickyFormObserver = null;
  var stickySyncPending = false;
  var stickyBar = null;

  function stickyForm(formId) {
    return formId ? document.getElementById(formId) : null;
  }
  function stickyBarsForForm(formId) {
    return Array.prototype.filter.call(document.querySelectorAll('[data-pq-sticky]'), function (bar) {
      return !formId || bar.getAttribute('data-form-id') === formId;
    });
  }
  function primaryCta(form) {
    if (!form) return null;
    var target = form.querySelector('[data-to-cart]');
    if (target && !/^(BUTTON|INPUT)$/.test(target.tagName)) {
      target = target.querySelector('button[data-to-cart], button[type="submit"], input[type="submit"]') || target.querySelector('button, input[type="submit"]') || target;
    }
    if (target) return target;
    // The theme renders a disabled sold-out submit without data-to-cart. Do not mistake an active
    // stock-notifier or other auxiliary submit button for the Add to Cart action.
    var submits = form.querySelectorAll('button[type="submit"], input[type="submit"]');
    for (var i = 0; i < submits.length; i++) {
      var label = (submits[i].textContent || '').trim();
      if (submits[i].disabled || submits[i].getAttribute('aria-disabled') === 'true' || /sold out/i.test(label)) return submits[i];
    }
    return null;
  }
  function targetIsBusy(target) {
    return !!(target && (
      target.disabled || target.getAttribute('aria-disabled') === 'true' ||
      target.getAttribute('aria-busy') === 'true' || target.classList.contains('!loading') ||
      target.hasAttribute('data-loading') || target.closest('[aria-busy="true"]') ||
      target.closest('product-to-cart') && target.closest('product-to-cart').classList.contains('!loading')
    ));
  }
  function primaryLabel(target) {
    if (!target) return 'Sold out';
    var addOne = target.querySelector && target.querySelector('[data-element="add-one"]');
    var addMany = target.querySelector && target.querySelector('[data-element="add-many"]');
    if (addMany && !addMany.hidden) return addMany.textContent.trim();
    return (addOne && !addOne.hidden ? addOne.textContent : target.textContent || '').trim();
  }
  function productRootForForm(form) {
    return form && (form.closest('.\\#product') || form.closest('.shopify-section')) || document;
  }
  function selectedVariantIdForForm(form) {
    if (!form) return '';
    var control = form.querySelector('[name="id"]');
    if (!control) {
      var id = form.getAttribute('id') || form.id;
      var associated = Array.prototype.find.call(document.querySelectorAll('[name="id"][form]'), function (el) {
        return el.getAttribute('form') === id;
      });
      if (associated) control = associated;
    }
    return control && control.value ? String(control.value) : '';
  }
  // Keep a user-selected quantity across theme/Appstle re-renders for the same variant.
  // A newly selected variant uses its own remembered value only when it is still a valid option;
  // otherwise Shopify's first valid quantity remains selected.
  var stickyQuantityByVariant = Object.create(null);
  function mainQuantityControl(form) {
    if (!form) return null;
    var control = form.elements && form.elements.namedItem ? form.elements.namedItem('quantity') : null;
    if (control && control.tagName) return control;
    return form.querySelector('[name="quantity"]');
  }
  function stickyQuantityKey(form) {
    return String(form && (form.getAttribute('id') || form.id) || '') + '|' + selectedVariantIdForForm(form);
  }
  function rememberMainQuantity(form, value) {
    if (!form) return;
    var quantity = value == null ? mainQuantityControl(form) : null;
    var selected = value == null ? quantity && quantity.value : value;
    if (selected == null || selected === '') return;
    stickyQuantityByVariant[stickyQuantityKey(form)] = String(selected);
  }
  function restoreMainQuantity(form) {
    var quantity = mainQuantityControl(form);
    if (!quantity) return;
    var wanted = stickyQuantityByVariant[stickyQuantityKey(form)];
    if (wanted == null || wanted === '' || String(quantity.value) === wanted) return;
    var validOption = quantity.options && Array.prototype.some.call(quantity.options, function (option) {
      return String(option.value) === wanted && !option.disabled;
    });
    if (!validOption) return;
    quantity.value = wanted;
    quantity.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function selectedVariantData(root, vid) {
    if (!root || !vid) return null;
    var scripts = root.querySelectorAll('[data-variants-json]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var variants = JSON.parse(scripts[i].textContent || '[]');
        for (var j = 0; j < variants.length; j++) if (String(variants[j].id) === String(vid)) return variants[j];
      } catch (e) { /* ignore invalid or partially-rendered theme JSON */ }
    }
    return null;
  }
  function stickyPriceText(form, root, vid) {
    var po = root.querySelector('[data-pq-po]');
    var priceBlock = po ? null : root.querySelector('[data-pq-price]');
    var source = po || priceBlock;
    var sourceVid = source && source.getAttribute('data-pq-sticky-source-variant');
    var variant = selectedVariantData(root, vid);
    var expectedRegular = variant && Number(variant.price);
    var actualRegular = NaN;
    if (po) {
      actualRegular = Number(po.getAttribute('data-one-time-price'));
      if (!(actualRegular > 0)) {
        var once = po.querySelector('.pq-po__price--once');
        if (once) actualRegular = parseMoney(once.textContent);
      }
    } else if (priceBlock) {
      actualRegular = Number(priceBlock.getAttribute('data-regular') || priceBlock.getAttribute('data-price'));
    }
    // Price blocks are stamped once when first rendered; a variant change must replace them before
    // their value is trusted again, even if two variants happen to share the same regular price.
    var sourceMatches = !(vid && sourceVid !== vid) && !(expectedRegular > 0 && actualRegular > 0 && actualRegular !== expectedRegular);
    if (!sourceMatches) {
      if (poState.mode === 'autoship' || !(expectedRegular > 0)) return '';
      var promo = promoByVid[vid];
      return money(promo && promo.cents > 0 && promo.cents < expectedRegular ? promo.cents : expectedRegular);
    }
    if (po) {
      if (poState.mode === 'autoship') {
        var first = po.querySelector('[data-pq-po-first]');
        return first ? first.textContent.trim() : '';
      }
      var oncePrice = po.querySelector('.pq-po__price--once');
      if (oncePrice) return oncePrice.textContent.trim();
    }
    var now = root.querySelector('[data-pq-price-now]');
    if (now) return now.textContent.trim();
    return expectedRegular > 0 ? money(expectedRegular) : '';
  }
  function stickyTargetVisible(target) {
    if (!target || !target.isConnected || target.hidden) return false;
    var r = target.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight || 0;
    var w = window.innerWidth || document.documentElement.clientWidth || 0;
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < h && r.right > 0 && r.left < w;
  }
  function stickyShouldShowForRect(rect, mobile, viewportWidth, viewportHeight) {
    if (!rect) return false;
    var visible = rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < viewportHeight && rect.right > 0 && rect.left < viewportWidth;
    return mobile ? !visible : (!visible && rect.top < 0);
  }
  function stickyViewportAllows(bar) {
    var mobile = window.matchMedia ? window.matchMedia('(max-width: 767px)').matches : (window.innerWidth || 0) <= 767;
    return mobile ? !bar.classList.contains('pq-sticky--no-mobile') : !bar.classList.contains('pq-sticky--no-desktop');
  }
  function stickyPurchaseOptions(form) {
    if (!form) return null;
    var root = productRootForForm(form);
    var options = root.querySelectorAll('[data-pq-po]');
    for (var i = 0; i < options.length; i++) {
      var input = options[i].querySelector('[data-pq-po-input]');
      if (input && (input.getAttribute('form') === form.id || input.form === form)) return options[i];
    }
    return null;
  }
  function syncStickyInterval(bar, form) {
    var po = stickyPurchaseOptions(form);
    var source = po && po.querySelector('[data-pq-po-select]');
    var active = poState.mode === 'autoship';
    var row = bar.querySelector('[data-pq-sticky-frequency]');
    if (!row) {
      row = document.createElement('div');
      row.className = 'pq-sticky__frequency';
      row.setAttribute('data-pq-sticky-frequency', '');
      row.hidden = true;
      var label = document.createElement('label');
      label.textContent = 'Deliver every';
      var select = document.createElement('select');
      select.id = 'pq-sticky-frequency-' + bar.getAttribute('data-form-id');
      select.setAttribute('data-pq-sticky-select', '');
      label.htmlFor = select.id;
      row.appendChild(label); row.appendChild(select);
      var note = document.createElement('small');
      note.className = 'pq-sticky__renewal';
      row.appendChild(note);
      var inner = bar.querySelector('.pq-sticky__inner');
      var button = inner.querySelector('.pq-sticky__btn');
      inner.insertBefore(row, button);
      select.addEventListener('change', function () {
        var currentForm = stickyForm(bar.getAttribute('data-form-id'));
        var currentPo = stickyPurchaseOptions(currentForm);
        var current = currentPo && currentPo.querySelector('[data-pq-po-select]');
        if (poState.mode !== 'autoship' || !current || current.disabled) { scheduleStickySync(); return; }
        var valid = Array.prototype.some.call(current.options, function (o) { return o.value === select.value && !o.disabled; });
        if (!valid) { scheduleStickySync(); return; }
        current.value = select.value;
        current.dispatchEvent(new Event('change', { bubbles: true }));
        scheduleStickySync();
      });
    }
    row.hidden = !active || !source || !source.options.length;
    if (row.hidden) return;
    var control = row.querySelector('[data-pq-sticky-select]');
    var signature = Array.prototype.map.call(source.options, function (o) { return [o.value, o.textContent, o.disabled]; });
    signature = JSON.stringify(signature);
    if (control.__pqSignature !== signature) {
      control.textContent = '';
      Array.prototype.forEach.call(source.options, function (o) {
        var copy = document.createElement('option');
        copy.value = o.value; copy.textContent = o.textContent; copy.disabled = o.disabled;
        control.appendChild(copy);
      });
      control.__pqSignature = signature;
    }
    control.value = source.value;
    control.disabled = source.disabled || !source.value;
    var ongoing = po.querySelector('[data-pq-po-ongoing]');
    var note = row.querySelector('.pq-sticky__renewal');
    var text = ongoing ? 'First-order price shown · then ' + ongoing.textContent.trim() + ' per delivery' : 'First-order price shown';
    if (note.textContent !== text) note.textContent = text;
  }
  var stickyNudged = false;
  function syncChatClearance(bar, visible) {
    if (!document.body || !document.body.style) return;
    if (!visible) {
      document.body.style.removeProperty('--pq-chat-clearance');
      return;
    }
    var rect = bar && bar.getBoundingClientRect ? bar.getBoundingClientRect() : null;
    var height = rect && rect.height || 0;
    if (height > 0) document.body.style.setProperty('--pq-chat-clearance', Math.ceil(height + 12) + 'px');
  }
  var stickyResizeObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      var bar = entry.target;
      syncChatClearance(bar, !!(document.body && document.body.classList.contains('pq-sticky-visible') && !bar.hidden));
    });
  }) : null;
  function observeStickySize(bar) {
    if (stickyResizeObserver && bar && !bar.__pqChatResizeObserved) {
      bar.__pqChatResizeObserved = true;
      stickyResizeObserver.observe(bar);
    }
  }
  function setStickyVisibility(bar, shown) {
    if (!bar) return;
    var visible = !!shown && stickyViewportAllows(bar);
    var wasHidden = bar.hidden;
    bar.toggleAttribute('hidden', !visible);
    if (visible && wasHidden && !stickyNudged && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      var nudge = bar.querySelector('[data-pq-sticky-btn]');
      if (nudge && !nudge.disabled) {
        stickyNudged = true;
        nudge.classList.add('pq-sticky__btn--nudge');
        nudge.addEventListener('animationend', function end() { nudge.classList.remove('pq-sticky__btn--nudge'); nudge.removeEventListener('animationend', end); });
      }
    }
    if (document.body) document.body.classList.toggle('pq-sticky-visible', visible);
    syncChatClearance(bar, visible);
  }
  function syncStickyBar(bar) {
    if (!bar || !bar.isConnected) return;
    var formId = bar.getAttribute('data-form-id');
    var form = stickyForm(formId);
    var target = primaryCta(form);
    var btn = bar.querySelector('[data-pq-sticky-btn]');
    if (!form || !target) {
      if (btn) { btn.disabled = true; btn.setAttribute('aria-disabled', 'true'); if (btn.textContent !== 'Sold out') btn.textContent = 'Sold out'; }
      setStickyVisibility(bar, false);
      return;
    }
    restoreMainQuantity(form);
    var busy = targetIsBusy(target);
    var unavailable = !target || busy || target.disabled || target.getAttribute('aria-disabled') === 'true';
    if (btn) {
      var label = poState.mode === 'autoship' ? CTA_AUTOSHIP : primaryLabel(target);
      if (label && btn.textContent !== label) btn.textContent = label;
      if (btn.disabled !== unavailable) btn.disabled = unavailable;
      if (unavailable) btn.setAttribute('aria-disabled', 'true'); else btn.removeAttribute('aria-disabled');
      if (busy) btn.setAttribute('data-pq-busy', 'true'); else btn.removeAttribute('data-pq-busy');
    }

    syncStickyInterval(bar, form);
    var root = productRootForForm(form);
    var vid = selectedVariantIdForForm(form);
    var variant = selectedVariantData(root, vid);
    var optionValues = Array.prototype.slice.call(root.querySelectorAll('[data-option-value]:checked')).sort(function (a, b) {
      return Number(a.getAttribute('data-option-index') || 0) - Number(b.getAttribute('data-option-index') || 0);
    }).map(function (el) { return el.value; }).filter(Boolean);
    var variantLabel = bar.querySelector('.pq-sticky__variant');
    if (variantLabel) {
      if (optionValues.length) variantLabel.textContent = optionValues.join(' / ');
      else if (vid && bar.getAttribute('data-pq-active-variant') && bar.getAttribute('data-pq-active-variant') !== vid) variantLabel.textContent = '';
    }
    if (vid) bar.setAttribute('data-pq-active-variant', vid);
    var priceEl = bar.querySelector('[data-pq-sticky-price]');
    var price = stickyPriceText(form, root, vid);
    if (priceEl && priceEl.textContent !== price) priceEl.textContent = price;
    if (priceEl && variant && Number(variant.price) > 0) priceEl.setAttribute('data-regular', String(variant.price));

    var visible = false;
    if (stickyTargetVisible(target)) {
      visible = false;
    } else {
      var r = target.getBoundingClientRect();
      var mobile = window.matchMedia ? window.matchMedia('(max-width: 767px)').matches : (window.innerWidth || 0) <= 767;
      visible = stickyShouldShowForRect(r, mobile, window.innerWidth || document.documentElement.clientWidth || 0, window.innerHeight || document.documentElement.clientHeight || 0);
    }
    setStickyVisibility(bar, visible);
  }
  function scheduleStickySync() {
    if (stickySyncPending) return;
    stickySyncPending = true;
    requestAnimationFrame(function () {
      stickySyncPending = false;
      document.querySelectorAll('body > [data-pq-sticky]').forEach(function (bar) { syncStickyBar(bar); });
      refreshStickyWatchers();
    });
  }
  function refreshStickyWatchers() {
    var bars = document.querySelectorAll('body > [data-pq-sticky]');
    stickyBar = bars.length ? bars[bars.length - 1] : null;
    var form = stickyBar ? stickyForm(stickyBar.getAttribute('data-form-id')) : null;
    var target = primaryCta(form);
    if (target !== stickyObservedTarget) {
      if (stickyObserver) stickyObserver.disconnect();
      stickyObservedTarget = target;
      if (target && typeof IntersectionObserver !== 'undefined') {
        if (!stickyObserver) stickyObserver = new IntersectionObserver(function () { scheduleStickySync(); }, { threshold: 0 });
        stickyObserver.observe(target);
      }
    }
    if (form !== stickyObservedForm) {
      if (stickyFormObserver) stickyFormObserver.disconnect();
      stickyObservedForm = form;
      if (form && typeof MutationObserver !== 'undefined') {
        stickyFormObserver = new MutationObserver(scheduleStickySync);
        stickyFormObserver.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'class', 'variant-id', 'value'] });
      }
    }
    if (stickyBar) syncStickyBar(stickyBar);
  }
  function bindSticky(root) {
    root.querySelectorAll('[data-pq-sticky]').forEach(function (bar) {
      observeStickySize(bar);
      var formId = bar.getAttribute('data-form-id');
      var btn = bar.querySelector('[data-pq-sticky-btn]');
      if (btn && !btn.__pqBound) {
        btn.__pqBound = true;
        btn.addEventListener('click', function () {
          var form = stickyForm(formId);
          var real = primaryCta(form);
          // Forward only a genuine, enabled primary-button click. Never bypass the theme/cart bridge.
          if (!form || !real || targetIsBusy(real) || real.disabled || real.getAttribute('aria-disabled') === 'true') return;
          real.click();
        });
      }
      var wrap = bar.closest('[data-meta-block]'); if (wrap) wrap.setAttribute('hidden', '');
      document.querySelectorAll('body > [data-pq-sticky]').forEach(function (old) { if (old !== bar) old.remove(); });
      if (bar.parentElement !== document.body) document.body.appendChild(bar);
    });
    ensureStickyListeners();
    refreshStickyWatchers();
  }
  function ensureStickyListeners() {
    if (window.__pqStickyListeners) return;
    window.__pqStickyListeners = true;
    window.addEventListener('scroll', scheduleStickySync, { passive: true });
    window.addEventListener('resize', scheduleStickySync, { passive: true });
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.name === 'quantity' && t.form) rememberMainQuantity(t.form, t.value);
      if (t && (t.name === 'quantity' || t.name === 'id' || t.hasAttribute('data-option-value') || t.hasAttribute('data-pq-po-radio') || t.hasAttribute('data-pq-po-select'))) scheduleStickySync();
    });
    document.addEventListener('shopify:section:load', scheduleStickySync);
  }

  /* ---------- Selly (Treedify) promotion listener ----------
   * Selly renders its own widget (#tdf_sale_widget) with the promo price for the selected variant:
   *   .tdf_price_sales[data-vp=<variantId>] .tdf_money[data-origin-value=<cents>]
   * We watch for it and, when it matches the selected variant, show the promo price in PQ orange in the
   * price block, the size tile, the Buy-once card and the sticky bar, recalculating $/kg from the promo.
   * When Selly has no offer for the selected variant everything reverts to the regular price. */
  function currentVariantId() {
    // ShowTime keeps the variant input outside the <form> and links it with form="..."
    var el = document.querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('input[name="id"][form]') || document.querySelector('[name="id"]');
    if (el && el.value) return String(el.value);
    var v = new URL(location.href).searchParams.get('variant');
    return v || '';
  }
  function readSelly() {
    var w = document.getElementById('tdf_sale_widget');
    if (!w) return null;
    var sales = w.querySelector('.tdf_price_sales[data-vp]');
    var m = sales && sales.querySelector('.tdf_money[data-origin-value]');
    var content = w.querySelector('.tdf_discount_content');
    var label = '';
    if (content) {
      for (var i = 0; i < content.childNodes.length; i++) {
        var n = content.childNodes[i];
        if (n.nodeType === 3 && n.nodeValue.trim()) { label = n.nodeValue.trim(); break; }
      }
    }
    return { vid: sales ? String(sales.getAttribute('data-vp')) : '', cents: m ? parseInt(m.getAttribute('data-origin-value'), 10) : NaN, label: label };
  }
  var sellyState = { active: false, cents: 0, vid: '' };
  // Selly only re-renders its widget for variants that have an offer, so after switching to a variant
  // without one the widget goes stale (still shows the previous variant). We therefore key everything
  // off a per-variant cache: an offer is only applied to the variant Selly reported it for.
  var promoByVid = {};
  /* ---------- Member Offer: illustrative average over the complete buy-N/get-one cycle ---------- */
  function updateMemberReference(vid, promo, planMode) {
    document.querySelectorAll('[data-pq-member-reference]').forEach(function (box) {
      var ownVid = box.getAttribute('data-variant-id');
      var panel = box.closest('[data-pq-rewards]');
      var offer = box.closest('[data-pq-member-offer]');
      var paid = Number(box.getAttribute('data-paid-units'));
      var free = Number(box.getAttribute('data-free-units'));
      var regular = Number(box.getAttribute('data-one-time-cents'));
      var unit = box.getAttribute('data-unit'), units = box.getAttribute('data-units');
      var valid = !!(vid && ownVid === vid && panel && panel.getAttribute('data-pq-variant-id') === vid && offer && offer.getAttribute('data-campaign-id'));
      valid = valid && Number.isSafeInteger(paid) && paid > 0 && free === 1 && Number.isSafeInteger(regular) && regular > 0 && !!unit && !!units;
      var cents = regular;
      if (promo && Number.isSafeInteger(promo.cents) && promo.cents > 0 && promo.cents < regular) cents = promo.cents;
      if (!valid || planMode) { if (!box.hidden) box.hidden = true; return; }
      // Currency is integer cents; round once at the displayed per-unit average.
      var average = Math.round(cents * paid / (paid + free));
      var tokens = { average: money(average), price: money(cents), paid: String(paid), total: String(paid + free), unit: unit, units: units };
      function copy(template) { return String(template || '').replace(/\[(average|price|paid|total|unit|units)\]/g, function (all, key) { return tokens[key]; }); }
      var value = box.querySelector('[data-pq-reference-value]');
      var note = box.querySelector('[data-pq-reference-note]');
      if (!value || !note) { if (!box.hidden) box.hidden = true; return; }
      var labelText = copy(box.getAttribute('data-label'));
      var noteText = copy(box.getAttribute('data-note'));
      if (value.textContent !== labelText) value.textContent = labelText;
      if (note.textContent !== noteText) note.textContent = noteText;
      if (box.hidden) box.hidden = false;
    });
  }

  function applySelly() {
    var raw = readSelly();
    if (raw && raw.vid && isFinite(raw.cents) && raw.cents > 0) promoByVid[raw.vid] = { cents: raw.cents, label: raw.label };
    var vid = currentVariantId();
    var info = promoByVid[vid] ? { vid: vid, cents: promoByVid[vid].cents, label: promoByVid[vid].label } : null;
    var active = !!info;
    var planMode = !!document.querySelector('[data-pq-po] [data-pq-po-radio][value="autoship"]:checked');

    // price block
    document.querySelectorAll('[data-pq-price]').forEach(function (pb) {
      var regular = parseInt(pb.getAttribute('data-regular') || pb.getAttribute('data-price'), 10);
      var weight = parseInt(pb.getAttribute('data-weight'), 10) || 0;
      var showUnit = pb.getAttribute('data-unit') === 'true';
      var now = pb.querySelector('[data-pq-price-now]');
      var was = pb.querySelector('[data-pq-promo-was]');
      var badge = pb.querySelector('[data-pq-promo-badge]');
      var unit = pb.querySelector('[data-pq-price-unit]');
      var on = active && info.cents < regular && !pb.classList.contains('is-plan');
      var save = pb.querySelector('[data-pq-promo-save]');
      if (on) {
        pb.classList.add('is-promo');
        if (now) now.textContent = money(info.cents);
        if (was) { was.textContent = money(regular); was.hidden = false; }
        if (save) { save.textContent = 'You save ' + money(regular - info.cents) + ' (' + Math.round((regular - info.cents) * 100 / regular) + '%)'; save.hidden = false; }
        if (badge) { badge.textContent = info.label; badge.hidden = !info.label; }
        if (unit && showUnit && weight > 0) { unit.textContent = money(Math.round(info.cents * 1000 / weight)) + ' / kg'; unit.hidden = false; }
        pb.querySelectorAll('[data-pq-price-was], [data-pq-price-save]').forEach(function (e) { e.hidden = true; });
      } else if (pb.classList.contains('is-promo')) {
        pb.classList.remove('is-promo');
        if (now) now.textContent = money(parseInt(pb.getAttribute('data-price'), 10));
        if (was) was.hidden = true;
        if (save) save.hidden = true;
        if (badge) badge.hidden = true;
        if (unit && showUnit && weight > 0) unit.textContent = money(Math.round(parseInt(pb.getAttribute('data-price'), 10) * 1000 / weight)) + ' / kg';
        pb.querySelectorAll('[data-pq-price-was], [data-pq-price-save]').forEach(function (e) { e.hidden = false; });
      }
    });

    // size tiles
    document.querySelectorAll('[data-pq-tile-vid]').forEach(function (t) {
      var tvid = t.getAttribute('data-pq-tile-vid');
      var regular = parseInt(t.getAttribute('data-pq-tile-price'), 10);
      var weight = parseInt(t.getAttribute('data-pq-tile-weight'), 10) || 0;
      var amount = t.querySelector('[class$="-item-amount"]');
      var unit = t.querySelector('[class$="-item-unit"]');
      var tp = promoByVid[tvid];
      var on = !!(tp && tp.cents < regular);
      if (on) {
        t.classList.add('is-promo');
        if (amount) amount.textContent = money(tp.cents);
        if (unit && weight > 0) unit.textContent = money(Math.round(tp.cents * 1000 / weight)) + '/kg';
      } else if (t.classList.contains('is-promo')) {
        t.classList.remove('is-promo');
        if (amount) amount.textContent = money(regular);
        if (unit && weight > 0) unit.textContent = money(Math.round(regular * 1000 / weight)) + '/kg';
      }
    });

    // Buy once card + sticky bar (only when not in Autoship mode)
    document.querySelectorAll('[data-pq-po]').forEach(function (po) {
      var once = po.querySelector('.pq-po__price--once');
      if (!once) return;
      var regular = parseInt(po.getAttribute('data-one-time-price') || '0', 10);
      if (!regular) { regular = Math.round(parseFloat(once.textContent.replace(/[^0-9.]/g, '')) * 100) || 0; po.setAttribute('data-one-time-price', String(regular)); }
      if (active && info.cents < regular) { once.classList.add('is-promo'); once.textContent = money(info.cents); }
      else if (once.classList.contains('is-promo')) { once.classList.remove('is-promo'); once.textContent = money(regular); }
    });
    if (!planMode) {
      document.querySelectorAll('[data-pq-sticky-price]').forEach(function (sp) {
        var regular = parseInt(sp.getAttribute('data-regular') || '0', 10);
        if (!regular) { regular = Math.round(parseFloat(sp.textContent.replace(/[^0-9.]/g, '')) * 100) || 0; sp.setAttribute('data-regular', String(regular)); }
        if (active && info.cents < regular) { sp.classList.add('is-promo'); sp.textContent = money(info.cents); }
        else if (sp.classList.contains('is-promo')) { sp.classList.remove('is-promo'); sp.textContent = money(regular); }
      });
    }

    updateMemberReference(vid, info, planMode);

    // Hide Selly's own box whenever the PQ price block owns promo display (not only while an offer is
    // active) — otherwise Selly's stale widget reappears after switching to a variant without an offer.
    var hide = !!document.querySelector('[data-pq-price][data-hide-selly="true"]');
    document.body.classList.toggle('pq-selly-promo', active);
    document.body.classList.toggle('pq-selly-hide', hide);
    if (active !== sellyState.active || (active && info.cents !== sellyState.cents)) {
      sellyState = { active: active, cents: active ? info.cents : 0, vid: active ? info.vid : '' };
      document.dispatchEvent(new CustomEvent('pq:promo', { detail: sellyState }));
    }
  }
  var sellyPending = false;
  function scheduleSelly() { if (sellyPending) return; sellyPending = true; requestAnimationFrame(function () { sellyPending = false; applySelly(); }); }
  function watchSelly() {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.nodeType === 1 && (t.id === 'tdf_sale_widget' || (t.closest && t.closest('#tdf_sale_widget')))) { scheduleSelly(); return; }
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.id === 'tdf_sale_widget' || (n.querySelector && n.querySelector('#tdf_sale_widget')))) { scheduleSelly(); return; }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
    document.addEventListener('change', function (e) {
      if (e.target && (e.target.name === 'id' || e.target.hasAttribute('data-option-value') || e.target.hasAttribute('data-pq-po-radio'))) {
        // Never leave the previous variant's illustration visible during an asynchronous swap.
        document.querySelectorAll('[data-pq-member-reference]').forEach(function (box) { if (!box.hidden) box.hidden = true; });
        setTimeout(scheduleSelly, 50);
      }
    });
    document.addEventListener('shopify:section:load', scheduleSelly);
    if (window.tdfEventHub && typeof window.tdfEventHub.ListenToEvents === 'function') {
      try { window.tdfEventHub.ListenToEvents(['widget_rendered', 'variant_changed', 'data_app2'], scheduleSelly); } catch (e) { /* optional */ }
    }
  }

  /* ---------- description "Read more" (pq-pdp-details section) ---------- */
  function bindClamp(root) {
    root.querySelectorAll('[data-pq-clamp-toggle]').forEach(function (btn) {
      if (btn.dataset.pqBound) return; btn.dataset.pqBound = '1';
      var body = btn.parentElement.querySelector('[data-pq-clamp]');
      if (!body) return;
      // hide the toggle when the text is short enough not to be clamped
      requestAnimationFrame(function () { if (body.scrollHeight <= body.clientHeight + 4) btn.hidden = true; });
      btn.addEventListener('click', function () {
        var open = body.classList.toggle('is-clamped') === false;
        btn.textContent = open ? btn.dataset.less : btn.dataset.more;
      });
    });
  }

  /* ---------- de-duplicate third-party widgets our blocks replace ----------
   * Appstle auto-injects its own plan picker (and a second input[name=selling_plan]) into the product form;
   * the REX connector injects a "Check stock in store" button into #cnc-container. When the PQ blocks are on
   * the page, those are removed so there is exactly one plan input and one stock checker. */
  function dedupe() {
    if (document.querySelector('[data-pq-po]')) {
      document.querySelectorAll('.appstle_sub_widget, .appstle_subscription_wrapper, [class^="appstle_"][class*="widget"]').forEach(function (w) {
        if (!w.closest('[data-pq-po]')) w.remove();
      });
    }
    if (document.querySelector('[data-pq-stock]')) {
      ['cnc-container', 'cnc-results-container'].forEach(function (id) { var el = document.getElementById(id); if (el) el.setAttribute('hidden', ''); });
    }
  }

  /* ---------- availability line beside the quantity selector (Chewy: "In stock · FREE delivery over $89") ---------- */
  /* ---------- CTA label: "Set up Autoship" when Autoship is selected (Chewy pattern) ---------- */
  var CTA_ONETIME = 'Add to cart';
  var CTA_AUTOSHIP = 'Subscribe & Save';
  function applyCtaLabel() {
    var autoship = poState.mode === 'autoship';
    var want = autoship ? CTA_AUTOSHIP : CTA_ONETIME;
    document.querySelectorAll('form[action*="/cart/add"] [data-to-cart] [data-element="add-one"], form[action*="/cart/add"] [data-to-cart] [data-element="add-many"], form[action*="/cart/add"] button[type="submit"] [data-element="add-one"], form[action*="/cart/add"] button[type="submit"] [data-element="add-many"]').forEach(function (el) {
      if (el.textContent !== want) el.textContent = want;
    });
    document.querySelectorAll('[data-pq-sticky]').forEach(function (bar) {
      var b = bar.querySelector('[data-pq-sticky-btn]'); if (!b) return;
      if (b.textContent !== want) b.textContent = want;
    });
    var box = document.querySelector('.pq-buybox'); if (box) box.classList.toggle('is-autoship', autoship);
    scheduleStickySync();
  }

  /* ---------- Rewards: points badge follows the shown price; balance from Yotpo Loyalty ---------- */
  function parseMoney(t) { var m = String(t || '').replace(/[^0-9.]/g, ''); return m ? Math.round(parseFloat(m) * 100) : NaN; }
  function updatePoints() {
    var panel = document.querySelector('[data-pq-rewards]'); if (!panel) return;
    var rate = parseFloat(panel.getAttribute('data-rate')) || 1;
    var now = document.querySelector('[data-pq-price-now]');
    var cents = now ? parseMoney(now.textContent) : NaN;
    if (isNaN(cents)) return;
    var pts = Math.floor(cents / 100 * rate);
    panel.querySelectorAll('[data-pq-points]').forEach(function (el) { if (el.textContent !== String(pts)) el.textContent = pts; });
    var copy = panel.querySelector('.pq-rewards__points-copy strong');
    if (copy) {
      if (!copy.__pqTpl) copy.__pqTpl = copy.textContent.replace(/\d[\d,]*/, '[points]');
      var want = copy.__pqTpl.replace('[points]', pts.toLocaleString());
      if (copy.textContent !== want) copy.textContent = want; // never write an unchanged value (observer loop)
    }
  }
  var pointsObserver = null, pointsPending = false;
  function watchPoints() {
    updatePoints();
    var section = document.querySelector('.\\#product') || document.body;
    if (pointsObserver) pointsObserver.disconnect();
    pointsObserver = new MutationObserver(function (muts) {
      // only react to mutations outside the rewards panel itself
      var outside = muts.some(function (m) { return !(m.target.closest && m.target.closest('[data-pq-rewards]')) && !(m.target.parentElement && m.target.parentElement.closest('[data-pq-rewards]')); });
      if (!outside || pointsPending) return;
      pointsPending = true;
      requestAnimationFrame(function () { pointsPending = false; updatePoints(); });
    });
    pointsObserver.observe(section, { childList: true, subtree: true, characterData: true });
  }
  // Member balance readiness and re-renders are isolated in pq-pdp-loyalty.js.

  function bindAvailability(root, instant) {
    var qtyBlock = document.querySelector('.pq-buybox > [data-block-type="quantity_selector"]');
    var ful = document.querySelector('[data-pq-ful]');
    if (!qtyBlock || !ful) return;
    var el = qtyBlock.querySelector('.pq-avail');
    if (!el) { el = document.createElement('div'); el.className = 'pq-avail'; qtyBlock.appendChild(el); }
    var available = ful.getAttribute('data-variant-available') === 'true';
    var klass = ful.getAttribute('data-class') || 'standard';
    // Bulky / heavy mirror the checkout rules (Bespoke v4.9): Bulky = no free freight (still ships);
    // any variant > 20 kg = no 2hr. Re-evaluated on every variant re-render (bindAll).
    var bulky = ful.classList.contains('is-bulky');
    var heavy = ful.classList.contains('is-heavy');
    var ship;
    if (isClosedDay(instant || new Date())) ship = '<span class="pq-avail__ship">Stores are closed today. 2hr delivery and Click &amp; Collect are unavailable today.</span>';
    else if (klass === 'livestock') ship = '<span class="pq-avail__ship pq-avail__ship--restricted">Click &amp; Collect only</span>';
    else if (klass === 'fresh' && heavy) ship = '<span class="pq-avail__ship pq-avail__ship--restricted">Click &amp; Collect only for this size <em>· can&rsquo;t be posted, over 20 kg for 2hr</em></span>';
    else if (klass === 'fresh') ship = '<span class="pq-avail__ship pq-avail__ship--restricted">Click &amp; Collect or 2hr Delivery only <em>· can&rsquo;t be posted</em></span>';
    else if (bulky && heavy) ship = '<span class="pq-avail__ship">Delivery calculated at checkout <em>· Click &amp; Collect · no 2hr (over 20 kg)</em></span>';
    else if (bulky) ship = '<span class="pq-avail__ship">Delivery calculated at checkout <em>· 2hr &amp; Click &amp; Collect</em></span>';
    else if (heavy) ship = '<span class="pq-avail__ship">FREE delivery over $89 in Sydney Metro &amp; Hunter <em>· Click &amp; Collect · no 2hr (over 20 kg)</em></span>';
    else ship = '<span class="pq-avail__ship">FREE delivery over $89 in Sydney Metro &amp; Hunter <em>· 2hr &amp; Click &amp; Collect</em></span>';
    el.classList.toggle('is-out', !available);
    el.innerHTML = '<span class="pq-avail__stock">' + (available ? 'In stock' : 'Out of stock online') + '</span>' + ship;
  }

  /* ---------- Afterpay: a <square-placement> moved by a theme re-render can stay blank; re-setting data-amount redraws it ---------- */
  function nudgeAfterpay() {
    document.querySelectorAll('square-placement[data-page-type="product"]').forEach(function (sp) {
      if (sp.getBoundingClientRect().height > 0 || sp.__pqNudged > 3) return;
      sp.__pqNudged = (sp.__pqNudged || 0) + 1;
      var now = document.querySelector('[data-pq-price-now]');
      var amt = now ? now.textContent.trim() : sp.getAttribute('data-amount');
      sp.setAttribute('data-amount', ''); sp.setAttribute('data-amount', amt);
    });
  }

  /* ---------- boot + re-bind after theme re-renders ---------- */
  function tagStickyPriceSources(root) {
    var vid = currentVariantId();
    if (!vid) return;
    root.querySelectorAll('[data-pq-po], [data-pq-price]').forEach(function (el) {
      // Never retag an existing node on variant change: only a freshly rendered price block may
      // claim the newly selected variant, preventing a stale same-price variant from looking current.
      if (!el.hasAttribute('data-pq-sticky-source-variant')) el.setAttribute('data-pq-sticky-source-variant', vid);
    });
  }
  function bindAll(root) {
    dedupe();
    tagStickyPriceSources(root);
    bindAvailability(root);
    scheduleSelly();
    bindClamp(root);
    bindPurchaseOptions(root);
    bindCutoff(root);
    bindStock(root);
    bindSticky(root);
    applyCtaLabel();
  }
  function boot() {
    bindAll(document);
    watchPoints();
    var section = document.querySelector('.\\#product') || document.body;
    var pending = false;
    var mo = new MutationObserver(function (muts) {
      // Reuse this product-root observer for sticky form/price rebinding; do not add another page-wide observer.
      var stickyChanged = muts.some(function (m) {
        var t = m.target;
        if (t && t.nodeType === 1 && t.closest && (t.closest('form[action*="/cart/add"]') || t.closest('[data-pq-po]') || t.closest('[data-pq-price]'))) return true;
        var nodes = Array.prototype.slice.call(m.addedNodes || []).concat(Array.prototype.slice.call(m.removedNodes || []));
        return nodes.some(function (n) {
          return n.nodeType === 1 && (n.matches('form[action*="/cart/add"],[data-to-cart],[data-pq-po],[data-pq-price]') || n.querySelector('form[action*="/cart/add"],[data-to-cart],[data-pq-po],[data-pq-price]'));
        });
      });
      if (stickyChanged) scheduleStickySync();
      // Re-bind all PQ controls only when a fresh PQ block arrives; our own text changes are ignored.
      var fresh = muts.some(function (m) {
        return Array.prototype.some.call(m.addedNodes || [], function (n) {
          return n.nodeType === 1 && (n.matches('[data-pq-po],[data-pq-ful],[data-pq-sticky],[data-pq-price],[data-pq-rewards]') || n.querySelector('[data-pq-po],[data-pq-ful],[data-pq-sticky],[data-pq-price],[data-pq-rewards]'));
        });
      });
      if (!fresh || pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; bindAll(document); });
    });
    mo.observe(section, { childList: true, subtree: true });
    // third-party widgets arrive late and re-inject after re-renders: sweep for 20s, then once a minute
    watchSelly();
    var sweeps = 0; var sw = setInterval(function () { dedupe(); applySelly(); nudgeAfterpay(); if (++sweeps > 40) clearInterval(sw); }, 500);
    setInterval(function () { bindCutoff(document); dedupe(); applySelly(); }, 60000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
